import { logoutUser, switchBranch } from "../../../core/services";
import { useAuthStore, useMenuStore } from "../../../core/stores";
import { AuthHandler } from "../../../core/http/auth.handler";
import { logger } from "../../utils";
import { useCallback, useState } from "react";
/**
 * useAuth — hook global untuk session management
 * Tersedia di semua MF via @pena/shared (tanpa react-query)
 *
 * @param onAfterLogout - callback opsional setelah logout (contoh: queryClient.clear())
 */
export const useAuth = (onAfterLogout) => {
    const clearAuth = useAuthStore((state) => state.clearSession);
    const clearMenus = useMenuStore((state) => state.clearMenus);
    const [logoutLoading, setLogoutLoading] = useState(false);
    const logout = useCallback(async () => {
        setLogoutLoading(true);
        try {
            await logoutUser();
        }
        catch (err) {
            // API logout gagal (network error, token expired, dll).
            // Refresh token mungkin masih valid di server — server side cleanup tidak terjamin.
            // Local session TETAP dibersihkan di finally untuk memastikan client-side aman.
            logger.warn("[AUTH] Logout API gagal — sesi lokal tetap dibersihkan.", {
                error: err?.message ?? String(err),
            });
        }
        finally {
            clearAuth();
            clearMenus();
            onAfterLogout?.();
            setLogoutLoading(false);
        }
    }, [clearAuth, clearMenus, onAfterLogout]);
    const [isSwitchingBranch, setIsSwitchingBranch] = useState(false);
    const handleSwitchBranch = useCallback(async (idCabang) => {
        setIsSwitchingBranch(true);
        try {
            const response = await switchBranch(idCabang);
            useAuthStore.getState().setSession(response.data);
            AuthHandler.notify("Berhasil!", "Berhasil pindah cabang!", "success");
            window.location.href = "/dashboard";
        }
        catch (err) {
            logger.error("[AUTH] Gagal berpindah cabang", err);
            AuthHandler.notify("Gagal!", "Gagal berpindah cabang.", "error");
            throw err;
        }
        finally {
            setIsSwitchingBranch(false);
        }
    }, []);
    const user = useAuthStore((s) => s.user);
    const lembaga = useAuthStore((s) => s.lembaga);
    const currentCabang = useAuthStore((s) => s.currentCabang);
    const availableCabang = useAuthStore((s) => s.availableCabang);
    const accessToken = useAuthStore((s) => s.accessToken);
    const accessExpiredAt = useAuthStore((s) => s.accessExpiredAt);
    return {
        logout,
        logoutLoading,
        user,
        lembaga,
        currentCabang,
        availableCabang,
        setCabang: handleSwitchBranch,
        isSwitchingBranch,
        accessToken,
        accessExpiredAt,
    };
};
